import { POSTConceptBody, POSTShopConceptBody, PUTConceptBody, PUTShopConceptBody } from './index'
import { IPaginatedRequest } from '../../request'

export const listConcepts = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/concepts',
  params
})

export const getConcept = (UUID: string) => ({
  method: 'GET',
  url: `/modules/concepts/${UUID}`
})

export const createConcept = (data: POSTConceptBody) => ({
  method: 'POST',
  url: '/modules/concepts',
  data
})

export const updateConcept = (UUID: string, data: PUTConceptBody) => ({
  method: 'PUT',
  url: `/modules/concepts/${UUID}`,
  data
})

export const listShopConcepts = (shopUUID: string, params: IPaginatedRequest) => ({
  method: 'GET',
  url: `/modules/shops/${shopUUID}/concepts`,
  params
})

export const getShopConcept = (conceptUUID: string) => ({
  method: 'GET',
  url: `/integration/tenderengine/${conceptUUID}`
})

export const createShopConcept = (shopUUID: string, data: POSTShopConceptBody) => ({
  method: 'POST',
  url: `/modules/shops/${shopUUID}/concepts`,
  data
})

export const updateShopConcept = (shopUUID: string, UUID: string, data: PUTShopConceptBody) => ({
  method: 'PUT',
  url: `/modules/shops/${shopUUID}/concepts/${UUID}`,
  data
})

export const getConceptParticipants = (conceptUUID: string, params: IPaginatedRequest) => ({
  method: 'GET',
  url: `/modules/shops/by-concept/${conceptUUID}`,
  params
})
